import React from "react";
import { Card, Button, Col, Row, Container, Badge } from "react-bootstrap";

const PricingCard = ({ title, price, period, features, highlight }) => {
  return (
    <Col lg={4} md={6} className="mb-4 ">
      <Card
        className={`h-100 text-center rounded-4 overflow-hidden ${
          highlight ? "shadow-lg border-primary" : "border-muted"
        }`}
      >
        <div
          className={`card-header ${
            highlight ? "bg-primary text-white" : "bg-light"
          }`}
        >
          {highlight && (
            <Badge
              bg="warning"
              className="position-absolute top-0 end-0 mt-3 me-3"
            >
              Popular
            </Badge>
          )}
          <h3 className="fw-bold mb-0">{title}</h3>
          <div className="py-4">
            <span className="display-6 fw-bold">{price}</span>
            <span className="fs-5">/{period}</span>
          </div>
        </div>
        <Card.Body className="d-flex flex-column p-4 background-dark">
          <p className="text-muted mb-4 landing-text-white">
            A tailored solution for individuals and teams alike.
          </p>
          <ul className="list-unstyled mb-4">
            {features.map((feature, index) => (
              <li key={index} className="mb-3 d-flex align-items-center">
                <span className="me-2">✓</span>
                <span className="text-start landing-text-white">
                  {feature.text}
                </span>
              </li>
            ))}
          </ul>
          <Button
            variant={highlight ? "warning" : "outline-primary"}
            className="mt-auto rounded-pill py-2 fw-semibold"
          >
            Get Started
          </Button>
        </Card.Body>
      </Card>
    </Col>
  );
};

const Price = () => {
  const plans = [
    {
      title: "Starter",
      price: "$29",
      period: "month",
      features: [
        { text: "Individual configuration" },
        { text: "No setup, or hidden fees" },
        { text: "Team size: 1 developer" },
        { text: "Premium support: 6 months" },
        { text: "Free updates: 6 months" },
      ],
      highlight: false,
    },
    {
      title: "Pro",
      price: "$49",
      period: "month",
      features: [
        { text: "Individual configuration" },
        { text: "No setup, or hidden fees" },
        { text: "Team size: 5 developers" },
        { text: "Premium support: 12 months" },
        { text: "Free updates: 12 months" },
      ],
      highlight: true,
    },
    {
      title: "Enterprise",
      price: "$99",
      period: "month",
      features: [
        { text: "Custom configuration" },
        { text: "No setup, or hidden fees" },
        { text: "Team size: 10+ developers" },
        { text: "Premium support: 24 months" },
        { text: "Free updates: 24 months" },
      ],
      highlight: false,
    },
  ];

  return (
    <section id="prices" className="py-5 bg-light background-dark">
      <Container>
        <Row className="text-center mb-5">
          <Col lg={8} className="mx-auto">
            <h5 className="display-6 mb-3">Choose Your Plan</h5>
            <p className="lead text-muted landing-text-white">
              Select the perfect plan for your needs. Upgrade or downgrade at
              any time.
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center ">
          {plans.map((plan, index) => (
            <PricingCard key={index} {...plan} />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Price;
